module.exports = __webpack_public_path__ + "static/media/close-modal.464478d8.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/close-modal.svg
// module id = 415
// module chunks = 1